import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const digitOrCommaRegex = /^[0-9,]{1}$/;

/**
 * @desc takes a string representing a price and converts it into a number.
 *  (string may incl. dots as separators, spaces, currency signs and so on)
 * @param {string} price
 * @returns {number} the price parsed as number
 */
export const priceToNumber: (price: string) => number = (price: string) => {
    price = price
        .split('')
        .filter((substr) => digitOrCommaRegex.test(substr))
        .map((substr) => (substr === ',' ? '.' : substr))
        .join('');

    return parseFloat(price);
};

export const priceMax: (max: number) => ValidatorFn =
    (max: number) =>
    (control: AbstractControl): ValidationErrors | null => {
        let value = control.value;
        if (typeof value === 'string') {
            value = priceToNumber(value);
        }
        if (typeof value === 'number' && !isNaN(value)) {
            return value > max ? { priceToHigh: true } : null;
        }
        return { noValidPrice: true };
    };

export const priceMin: (min: number) => ValidatorFn =
    (min: number) =>
    (control: AbstractControl): ValidationErrors | null => {
        let value = control.value;
        if (typeof value === 'string') {
            value = priceToNumber(value);
        }
        if (typeof value === 'number' && !isNaN(value)) {
            return value < min ? { priceTooLow: true } : null;
        }
        return { noValidPrice: true };
    };
